import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GuideService, GuideSection } from '@app/_v2/games/services/guide.service';

@Component({
  selector: 'app-game-rules-modal',
  templateUrl: './game-rules-modal.component.html',
  styleUrls: ['./game-rules-modal.component.scss'],
})
export class GameRulesModalComponent implements OnInit, OnChanges {
  sections: GuideSection[] = [];
  selectedIndex: number = 0; // Current section slider

  tabs: string[];
  selectedTab: string;

  constructor(public router: Router, public guide: GuideService) {}

  ngOnInit() {
    this.tabs = ['gameplay', 'rules'];
    this.selectedTab = this.tabs[0];

    this.sections = this.guide.fetchSections;
  }

  ngOnChanges() {}

  public left() {
    this.selectedIndex--;
  }

  public right() {
    this.selectedIndex++;
  }

  public stopShow() {
    this.guide.setVisibilityToCurrentGame(false);
    this.router.navigate(['/', { outlets: { modal: null } }]);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/game-rules/game-rules-modal.component.ts